import StringBuffer from '../lib/StringBuffer';

const $ = require('jquery');

/**
 *  Našeptávač pro vyhledávání
 */
$.fn.fulltextSearch = function () {
	const lang = window.projectConfig.lang || 'cs';
	const i18n = {
		cs: {
			resultInfo: `Hledaný výraz nebyl na webu našeptávačem nalezen.<br>Pro prohledání celého webu klikněte <a href="#">zde</a> nebo stiskněte enter.`,
			showAll:    `zobrazit všechny výsledky`,
		},
	};

	$(this).each(function () {
		let $t                = $(this),
		    postURL           = '/qf/cs/ramjet/autocomplete',
		    $input            = $('input[type="search"]:first', $t),
		    keyUpTimer        = null,
		    $renderedResult   = null,
		    valBeforeKeyPress = '';

		$input.off('keydown').on('keydown', function (e) {
			if (e.keyCode === 13) {
				e.preventDefault();
				$(this).parents('form:first').submit();
			}
		});

		const performSearch = function (searchString) {
			$t.addClass('loading');
			$.get(postURL, {
				'frm.query': searchString,
			}, function (data) {
				let itemSize = $(data).find('li').length;
				renderResults(searchString, [data]);
			}, 'html');
		};

		const renderResults = function (str, dt) {
			let selectedItem = -1;
			const searchResult = new StringBuffer();

			if (dt && dt.length > 0) {
				searchResult.append('<ul class="autocomplete">');
				for (let i = 0; i < dt.length; i++) {
					if (dt[ i ].trim() !== '') {
						$(dt[ i ]).find('li').each(function () {
							searchResult.append($(this)[ 0 ].outerHTML);
						});
					}
				}
				searchResult.append('</ul>');
			}

			if ($renderedResult) {
				$renderedResult.remove();
			}

			$t.removeClass('loading');

			$t.append('<div class="autocompleteWrapper"></div>');
			$renderedResult = $('.autocompleteWrapper', $t);
			const GA_NumResult = $('ul', $renderedResult).find('li').length;
			if (searchResult.getString() === '<ul class="autocomplete"></ul>') {
				$renderedResult.append(`<p class="resultInfo">${ i18n[ lang ][ 'resultInfo' ] }</p>`);
				$('.resultInfo', $renderedResult).on('click', function (e) {
					e.preventDefault();
					$(this).parents('form:first').submit();
				});
			} else {
				$renderedResult.append(searchResult.getString());
				$('ul', $renderedResult).append(`<li class="showAll"><a href="#">${ i18n[ lang ][ 'showAll' ] }</a></li>`);
				$('li:last', $renderedResult).addClass('last').on('click', function (e) {
					e.preventDefault();
					$(this).parents('form:first').submit();
				});
			}

			// $.log(Number(GA_NumResult),"počet položek do GA");
			/*dataLayer.push({
				event: "cGtmFulltextAutocomplete",
				vGtm1: str,
				vGtm2: Number(GA_NumResult),
				vGtm3: "cs"
			});*/

			$input.off('keydown').on('keydown', function (e) {
				valBeforeKeyPress = $input.val();
				const liCnt = $('li', $renderedResult).length;

				// $.log(selectedItem,"selectedItem");

				// down
				if (e.keyCode === 40) {
					e.preventDefault();
					if (selectedItem < liCnt - 1) {
						selectedItem++;
					}
				}

				// up
				if (e.keyCode === 38) {
					e.preventDefault();
					if (selectedItem > 0) {
						selectedItem--;
					}
				}

				//enter
				if (e.keyCode === 13) {
					e.preventDefault();
					if (selectedItem > -1 && selectedItem < $('li', $renderedResult).length - 1) {
						window.location.href = $('li:eq(' + selectedItem + ')', $renderedResult).find('a').prop('href');
					} else {
						$(this).parents('form:first').submit();
					}
				}

				//escape
				if (e.keyCode === 27) {
					e.preventDefault();
					$renderedResult.remove();
				}

				$('li', $renderedResult).removeClass('active');
				$('li:eq(' + selectedItem + ')', $renderedResult).addClass('active');
			});

			$input.off('blur').on('blur', function (e) {
				e.preventDefault();
				setTimeout(function () {
					//$renderedResult.remove();
				}, 200);
			});

			$('li', $renderedResult).on('mouseover', function () {
				$('li', $renderedResult).removeClass('active');
				$(this).addClass('active');
				selectedItem = $('li', $renderedResult).index(this);
			});
		};

		$input.prop('autocomplete', 'off');

		$input.on('keyup', function (e) {
			clearTimeout(keyUpTimer);
			const val = $(this).val();
			if (valBeforeKeyPress === val) return false;
			if (val.length > 3) {
				keyUpTimer = setTimeout(function () {
					performSearch(val);
				}, 400);

			} else {
				if ($renderedResult) {
					$renderedResult.remove();
				}
			}
		});
	});
};



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/web/jquery.fulltextSearch.js